import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0eb644c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order-guide" }
const _hoisted_2 = { class: "order-guide-content" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["href"]

import { ref, computed, onMounted } from 'vue'
import EstimatePrice from '@/components/guide/estimatePrice/index.vue'
import data from './data'
import { useStore } from 'vuex'
import { useSite, isJA } from '@/store'

export default /*#__PURE__*/_defineComponent({
  props: {
  name: {
    type: String,
    default: ''
  }
},
  emits: ['close'],
  setup(__props, { emit: emits }) {

const props = __props
const store = useStore()


const estimatePriceShow = ref(false)
const computedIndex: any = ref(0)
const isFinish = ref(false)
const next: any = () => {
  console.log(data[props.name].length, computedIndex.value)
  if(data[props.name].length === computedIndex.value + 1) return
  computedIndex.value++
}
const info: any = computed(() => {
  return data[props.name][computedIndex.value]
})
const showGuide: any = computed(() => {
  /** 工作台新手引导去除 */
  if (['b2b-usercenter', 'd2c-usercenter'].includes(props?.name)) {
    return false
  }
  // 日本才有新手引导
  return !store.state.guide.guideState[props.name] && isJA()
})

const showEstimatePriceShow = computed(() => {
  // 日本才有成本计算引导
  return !store.state.guide.guideState['estimate-price'] && isJA()
})

onMounted(() => {
  if (!showGuide.value && showEstimatePriceShow.value) {
    setTimeout(() => {
      estimatePriceShow.value = true
    }, 500)
  }
})
const isLogin = computed(() => store.getters.isLogin)
const close = (isEmits?:boolean) => {
  // 如果成本计算器引导没展示过，那么展示成本计算器的引导
  if (!store.state.guide.guideState['estimate-price']) {
    store.dispatch('guide/changeGuideStatus', { key: props.name, value: true })
    setTimeout(() => {
      estimatePriceShow.value = true
    }, 200)
    return
  }
  store.dispatch('guide/changeGuideStatus', { key: props.name, value: true })
  if (!isEmits) return
  emits('close')
}
store.dispatch('guide/getGuide', { customerId: store.getters.user?.customerId }).then(() => {
  isFinish.value = true
})

const closeCalllback = () => {
  estimatePriceShow.value = false
}
// 清空状态
// store.dispatch('guide/resetGuide')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          referrerPolicy: "no-referrer",
          src: _unref(info).imgSrc,
          alt: "",
          onClick: next
        }, null, 8, _hoisted_3),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(info).stepBtn, (i, k) => {
          return (_openBlock(), _createElementBlock("div", {
            style: _normalizeStyle({
        height: i.height,
        width: i.width,
        top: i.top,
        left: i.left,
      }),
            key: k,
            class: "step-btn",
            onClick: _withModifiers(next, ["stop"])
          }, null, 12, _hoisted_4))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(info).returnBtn, (i, k) => {
          return (_openBlock(), _createElementBlock("div", {
            style: _normalizeStyle({
        height: i.height,
        width: i.width,
        top: i.top,
        left: i.left,
      }),
            key: k,
            class: "return-btn",
            onClick: _withModifiers(() => close(i.isEmits), ["stop"])
          }, null, 12, _hoisted_5))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(info)?.linkBtn ?? [], (i, k) => {
          return (_openBlock(), _createElementBlock("a", {
            style: _normalizeStyle({
        height: i.height,
        width: i.width,
        top: i.top,
        left: i.left,
      }),
            key: k,
            class: "return-btn",
            href: i.href,
            target: "_blank"
          }, null, 12, _hoisted_6))
        }), 128))
      ])
    ], 512), [
      [_vShow, _unref(showGuide) && isFinish.value && _unref(isLogin)]
    ]),
    (estimatePriceShow.value)
      ? (_openBlock(), _createBlock(EstimatePrice, {
          key: 0,
          name: "estimate-price",
          onCalllback: closeCalllback
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})